import * as React from "react"
const SvgComponent = ({width = 400, height = 382}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} data-name="Layer 1" viewBox="0 0 400 382.02">
        <defs>
            <clipPath id="a">
                <path
                    d="M238.11 159.01s9.38-4.84 3.71-21.57c0 0 10.56-.5 7.83-16.12 0 0 15.18 1.08 12.15-14.01 0 0 10.87-.64 7.16-13.79 0 0 11.45.07 8.72-13.55-2.73-13.61 45.18-16.38 45.18-16.38s42.6.72 45.84 8.75c3.23 8.02 14.01 44.66 14.55 48.43.54 3.77 2.16 37.45-2.69 43.24-4.85 5.79-8.08 18.18-16.7 25.19-8.62 7 3.69 15.61-40.99 24.13-44.68 8.53-54.9 17.52-65.78 9.6-10.88-7.92-18.97-63.93-18.97-63.93Z"
                    style={{
                        fill: "none",
                        strokeWidth: 0,
                    }}
                />
            </clipPath>
        </defs>
        <path
            d="M228.64 153.91s47.32 7.05 77.6 42.63c30.29 35.59 53 87.83 53 87.83l-65.3 11.36v87.46H80.83l10.42-76.13H1.97s3.74-19.29 14.05-31.83c4.15-5.05 6.76-11.12 7.76-17.58 2.17-14 9.93-26.47 19.97-34.45 4.87-3.87 8.47-9.11 10.52-14.99 12.33-35.42 75.35-51.55 97.58-57.44l76.79 3.15Z"
            style={{
                fill: "#b51a1a",
                strokeWidth: 0,
            }}
        />
        <path
            d="m169.56 383.16 52.96-54.09s24.2-1.51 39.12-12.47h-59.73l-93.56 66.56h61.22Z"
            style={{
                fill: "#35150b",
                strokeWidth: 0,
            }}
        />
        <path
            d="M293.9 213.34v82.35"
            style={{
                fill: "none",
                stroke: "#35150b",
                strokeMiterlimit: 10,
            }}
        />
        <path
            d="m228.6 153.87-76.79-3.15c-2.13.57-4.65 1.23-7.46 1.99 16.37 25 67.7 33.91 90.32 2.38-3.83-.89-6.07-1.23-6.07-1.23Z"
            style={{
                fill: "#005e9d",
                strokeWidth: 0,
            }}
        />
        <path
            d="m112.69 301.5 14.53-60.81M196.38 228.07l11.06 20.84"
            style={{
                fill: "none",
                stroke: "#35150b",
                strokeMiterlimit: 10,
            }}
        />
        <path
            d="M25.26 307.02h86.11l-3.76 17.01 105.94-32.98 10.33-15.45c2.09-3.12 5.05-5.57 8.51-7.03l7.18-3.03c2.07-.87 4.46.01 5.46 2.03.93 1.87.35 4.14-1.35 5.35l-7.57 5.36-3.38 11.66 24.44-.75s10.13-5.66 16.27-8.35c6.15-2.7 7.5 3.6 4.2 7.95 4.95 2.4 2.6 6.75 1.75 7.8 2.9 2.4-1.45 7.5-1.45 7.5s.75 2.7-3.15 6.6c-3.9 3.9-13.04 14.69-56.82 12.14 0 0-71.93 48.05-107.15 69.73-35.22 21.68-117.41 17.16-85.56-85.5Z"
            style={{
                fill: "#fdebd4",
                strokeWidth: 0,
            }}
        />
        <path
            d="m110.49 310.97.87-3.95h-86.1c-.97 3.11-1.83 6.14-2.58 9.07-1.23 4.77 2.9 9.2 7.75 8.39l80.06-13.5Z"
            style={{
                fill: "#35150b",
                strokeWidth: 0,
            }}
        />
        <path
            d="m107.6 324.03-37.08 10.08M276.55 289.1s-13.52 8.51-25.03 8.26M276.55 297.36s-13.52 8.51-25.03 8.26M276.55 305.63s-13.52 8.51-25.03 8.26M10.97 290.35h104.38"
            style={{
                fill: "none",
                stroke: "#35150b",
                strokeMiterlimit: 10,
            }}
        />
        <path
            d="M217.83 116.5v33.7l10.77 3.67c-23.02 22.56-63.94 16.79-76.79-3.15l9.97-3.67 3.41-44.42 52.65 13.87Z"
            style={{
                fill: "#fdebd4",
                strokeWidth: 0,
            }}
        />
        <path
            d="M174.5 110.09s6.49 23.25 30.32 31.97c6.32 2.31 13.01-2.41 13.01-9.13v-16.42l-43.33-6.41Z"
            style={{
                fill: "#35150b",
                strokeWidth: 0,
            }}
        />
        <path
            d="m238.11 47.27-6.04 34.27c12.73 17.79-1.43 47.64-31.8 45.36-30.37-2.28-36.9-29.21-36.9-29.21l14.52-57.27 60.21 6.85Z"
            style={{
                fill: "#fdebd4",
                strokeWidth: 0,
            }}
        />
        <path
            d="M247.7 9.27c-5.66 0-10.85 2.01-14.9 5.36-6.12-5.03-15.8-8.29-26.73-8.29-10.27 0-19.45 2.87-25.6 7.39a20.312 20.312 0 0 0-9.95-2.59c-10.91 0-19.79 8.55-20.39 19.31-.7-.08-1.41-.13-2.14-.13-10.24 0-18.54 8.3-18.54 18.54s8.3 18.54 18.54 18.54c1.79 0 3.52-.27 5.16-.74l3.19 13.32h18.23c8.55-8.94 11.72-19.5 12.85-24.99 2.16.88 4.52 1.38 7 1.38 6.45 0 12.12-3.29 15.44-8.29 3.21 4.51 8.48 7.47 14.44 7.47 3.9 0 7.5-1.28 10.43-3.42a23.26 23.26 0 0 0 12.97 3.93c12.92 0 23.4-10.47 23.4-23.4s-10.47-23.4-23.4-23.4Z"
            style={{
                fill: "#f6cb00",
                strokeWidth: 0,
            }}
        />
        <path
            d="M202.92 76.45a4.11 4.11 0 1 1-8.22 0 4.11 4.11 0 0 1 8.22 0ZM228.6 76.45a4.11 4.11 0 1 1-8.22 0 4.11 4.11 0 0 1 8.22 0ZM215.01 105.05c-.67 6.32-3.75 11.45-6.87 11.45s-5.1-5.13-4.43-11.45c.67-6.32 3.75-11.45 6.87-11.45s5.1 5.13 4.43 11.45Z"
            style={{
                fill: "#0e1c2c",
                strokeWidth: 0,
            }}
        />
        <path
            d="M209.05 103.68c-1.76 0-3.48.1-5.16.26-.06.37-.13.73-.17 1.11-.67 6.32 1.31 11.45 4.43 11.45s6.19-5.13 6.87-11.45c.04-.35.04-.68.06-1.02-1.94-.22-3.95-.35-6.02-.35Z"
            style={{
                fill: "#b51a1a",
                strokeWidth: 0,
            }}
        />
        <path
            d="M188.94 63.6s6.34-4.97 15.92-1.53M217.83 63.6s3.74-3.44 13.32 0"
            style={{
                fill: "none",
                stroke: "#0e1c2c",
                strokeMiterlimit: 10,
                strokeWidth: "1.97px",
            }}
        />
        <path
            d="m178.63 81.13-9.83-5.88c-7.1-4.25-16.16-3.3-22.22 2.35a15.531 15.531 0 0 0-3.98 16.72c2.89 7.83 11.45 11.97 19.38 9.37l10.45-3.42 6.2-19.13Z"
            style={{
                fill: "#fdebd4",
                strokeWidth: 0,
            }}
        />
        <path
            d="m213.54 72.6-1.01 8.88 3.02 6.36h-12.14M147.86 84.87s14.19-5.3 23.09 4.48M157.34 93.52V83.38"
            style={{
                fill: "none",
                stroke: "#581c1c",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: ".99px",
            }}
        />
        <path
            d="M200.74 95.86c0 4.43-3.59 8.02-8.02 8.02s-8.02-3.59-8.02-8.02 3.59-8.02 8.02-8.02 8.02 3.59 8.02 8.02Z"
            style={{
                fill: "#b51a1a",
                strokeWidth: 0,
            }}
        />
        <path
            d="M233.81 156.82s-4.42 6.68-6.42 7.66-4.43.16-5.41-1.84c-.99-2-.16-4.43 1.84-5.41 2-.99 9.99-.41 9.99-.41ZM234.67 133.82s-4.19 3.02-5.63 3.16-2.71-.91-2.85-2.35.91-2.71 2.35-2.85 6.12 2.04 6.12 2.04ZM253.15 94.44s-4.72-2.11-5.56-3.28a2.61 2.61 0 0 1 4.24-3.04c.84 1.17 1.31 6.32 1.31 6.32ZM265.05 85.79s-5.23-5.67-5.69-7.77c-.46-2.1.87-4.18 2.97-4.64s4.18.87 4.64 2.97-1.92 9.44-1.92 9.44ZM217.35 105.87c.04-.09.06-.2.07-.31.09-.79.59-2.34-.1-2.94-.54-.47-.96-.16-1.22.38s-.59 1.66-.53 2.27c.07.67 1.39 1.43 1.79.59ZM202.54 106.51c.01.22.02.44 0 .66-.06.86-.52 1.31-1.38 1.33-.34 0-.71 0-.96-.24-.18-.17-.26-.42-.3-.67-.25-1.39.31-2.86.46-4.24.02-.22.04-.44.14-.63.32-.62 2.43-1.68 2.85-.76.1.23.07.5-.03.74s-.25.44-.38.66c-.61 1.02-.46 2.02-.4 3.15ZM204.23 115.63c.45.73 1.08 1.34 1.82 1.77.22.13.44.24.61.43.13.15.21.33.26.51.21.71.07 1.51-.38 2.1-.23.31-.54.55-.86.77-.82.56-1.82.98-2.78.76-.33-.07-.68-.27-.72-.6-.04-.34.25-.61.47-.87.58-.7.76-1.71.45-2.56-.13-.35-.33-.69-.32-1.06.02-.44.37-.83.79-.96M258.02 183.04c-.88-1.21-2.23-2.17-3.77-2.66-1.77-.56-3.7-.75-5.54-1.17-2.12-.49-4.21-1.34-5.67-2.73s-2.08-3.39-4.28-4.17c-1.68-.59-4.05-.08-4.85 1.39-.66 1.21-.09 2.57-.27 3.87-.73 5.06-8.93 3.86-12.69 3.49-5.68-.56-4.34 4.1-1.08 5.76 1.26.64 2.4 1.76.76 2.84-1.72 1.13-3.65 2.22-4.52 3.9-.91 1.77-.35 3.85 1.08 5.2 3.55 3.36 10.37.8 13.19 5.13.51.79.81 1.69 1.46 2.4 2.41 2.68 6.76 1.31 9.44-.73 4.99-3.78 1.63-10.84 8.11-13.55 2.02-.84 4.23-.74 6.27-1.45 1.64-.57 2.78-1.61 3.22-3.06.48-1.59.08-3.16-.86-4.45Z"
            style={{
                fill: "#f6cb00",
                strokeWidth: 0,
            }}
        />
        <path
            d="M224.49 193.17c.15 2.47.43 4.63.76 4.39 0 0 .23-.08.18-.53-.02-.2-.12-1.93-.27-4.11.54-.23 1.24-.53 1.9-.77 0 .51.01 1.01.03 1.49.14 2.8 1.28 2.84 1.96 2.53.16-.08.25-.29.19-.43-.25-.6-.43-2.23-.55-4.08.2-.01.37-.01.47.04.04.03.11-.02.12-.07.08-.32.16-.91-.65-.85-.14-2.57-.2-5.28-.28-5.94-.12-1.2-1.16-.78-1.6-.54-.11.06-.15.18-.11.26.43.76.38 3.87.4 6.71-.56.24-1.29.57-1.94.82-.08-1.17-.29-4.11-.33-4.79-.06-.99-.44-1.06-.67-.96-.21.1-.09 1.15-.09 1.15.06.77.33 3.24.42 4.81-.29.08-.55.14-.71.11-.06-.02-.14.05-.14.13 0 .32.15.86.91.61Zm3.51-8.55s-.04.18-.3-.03c-.12-.14-.22-.22-.34-.25 0 0 .66-.08.64.28ZM231.38 193.5c.76-.19 1.22-1.17 1.49-2.18 0 .61.03 1.19.06 1.65.12 1.63 1.28 1.05 1.28 1.05.98-.47 1.61-2.35 1.96-3.81.01.58.02 1.15.05 1.58.14 1.62 1.29 1.04 1.29 1.04.96-.46 1.58-2.26 1.93-3.71.16.95.59 1.95 1.71 1.82 1.78-.21 2.56-2.49 2.56-2.49.09-.22.17-.46.24-.69.04.45.09.82.15 1.08.34 1.36 1.02.85 1.02.85.09-.03.14-.28.17-.63.15-1.52.62-5.45 1.29-5.41 0 0 .15.03.1.72-.05.77-.54 4.35.56 4.44.9.1 1.36-.86 1.36-.86.88-1.72 1.23-4.37 1.23-4.37a.573.573 0 0 0-.15-.47c-.04-.05-.13 0-.14.07-.59 2.75-1.1 4.59-1.55 4.59-.52 0-.38-2.57-.39-3.99 0 0 .08-1.21-.86-.91-.78.26-1.24 1.65-1.49 3.04-.04-2.88-.12-5.84-.27-6.37-.26-.84-1.29-.57-1.72-.42-.09.03-.15.16-.11.24.11.26.25.8.35 1.48.2 1.64.27 3.75.36 5.45-.16.73-.35 1.43-.62 2.12 0 0-.7 1.84-1.89 1.8-.82-.03-.67-2.26-.67-2.26.09-1.09.31-2.27.52-2.48.36-.39.58.46.64.83 0 .08.1.11.15.05.39-.39.53-.72.34-.98 0 0-.64-1.03-1.78-.17-.46.34-.79.94-.98 1.57v.01c0 .04-.02.08-.03.12-.04.14-.07.29-.1.43-.55 2.45-1.02 4.06-1.44 4.06-.3 0-.39-.84-.4-1.83.03-1.82.06-3.89.03-5.36.84-.34.96-.47.97-.55.03-.09.01-.29-.44-.15-.09.03-.29.1-.54.17 0-.67-.02-1.17-.08-1.34-.22-.8-1.08-.67-1.57-.53-.16.04-.26.24-.21.38.1.29.2.78.25 1.4.02.22.03.41.05.65-.68.25-.74.27-.86.33-.3.15-.2.44-.2.44.07.16.14.15 1.1-.21.05 1.14.05 2.46.05 3.63-.55 2.51-1.04 4.17-1.47 4.16-.52 0-.36-2.58-.37-4 0-.75-.47-.91-.91-.89-.53.05-.64.58-.66.75-.14 2.51-.52 3.93-.97 3.93-.52-.02-.48-1.72-.49-3.14-.01-1.01-.73-.92-1.3-.63-.07.03-.12.14-.09.22.04.09.05.18.09.42.11.65.12 1.71.21 2.96.09 1.68 1.19 1.34 1.19 1.34Zm15.9-9.84c-.13-.42-.58-.46-.54-.5.66-.38.54.5.54.5Zm-2.6-4.03s-.07.23-.3-.01c-.12-.12-.19-.26-.28-.28 0 0 .59-.05.58.3Zm-2.51 6.15c-.03-.17-.16-.31-.28-.47 0 0 .47.02.28.47Zm-4.93-3.33s-.08.21-.28-.04c-.12-.14-.17-.26-.27-.31 0 0 .59-.01.55.35Zm-3.24 5.99c-.04.38-.3-.42-.37-.42 0 0 .39.04.37.42Zm-2.95.86c-.13-.42-.56-.47-.52-.5.64-.37.52.5.52.5ZM247.97 189.89c-.17.05-2.19.69-3.29 1.06-2.18.73-4.34 1.53-6.5 2.34-2.16.81-4.31 1.63-6.45 2.47-1.98.78-3.96 1.56-5.93 2.35-.29.12-.61.26-.74.55-.1.24 0 .66.1.9.08.21.27.45.49.4.14-.03.23-.17.32-.29.63-.87 1.67-1.29 2.61-1.72 1.17-.54 2.32-.93 3.47-1.43 2.11-.92 4.24-1.78 6.36-2.67 2.12-.89 4.26-1.72 6.41-2.54.65-.25 1.6-.7 2.33-.51.22.06.42.11.66.06.27-.06.37-.19.47-.4.22-.48.69-.71 1.16-.89 0-.03 2.3-.84 2.3-.87-.49.12-4.23 1.34-3.77 1.19Z"
            style={{
                fill: "#00553c",
                strokeWidth: 0,
            }}
        />
        <g
            style={{
                clipPath: "url(#a)",
            }}
        >
            <ellipse
                cx={293.33}
                cy={152.99}
                rx={55.86}
                ry={39.65}
                style={{
                    fill: "#d97533",
                    strokeWidth: 0,
                }}
            />
            <path
                d="M282.17 163.34c-2.53 9.58-12.35 15.29-21.93 12.75-9.58-2.53-15.29-12.35-12.75-21.93 2.53-9.58 12.35-15.29 21.93-12.75 9.58 2.53 15.29 12.35 12.75 21.93Z"
                style={{
                    fill: "#b51a1a",
                    strokeWidth: 0,
                }}
            />
            <path
                d="M314.3 167.86c-2.53 9.58-12.35 15.29-21.93 12.75-9.58-2.53-15.29-12.35-12.75-21.93 2.53-9.58 12.35-15.29 21.93-12.75 9.58 2.53 15.29 12.35 12.75 21.93Z"
                style={{
                    fill: "#b51a1a",
                    strokeWidth: 0,
                }}
            />
            <path
                d="M341.05 161.49c-2.53 9.58-12.35 15.29-21.93 12.75-9.58-2.53-15.29-12.35-12.75-21.93 2.53-9.58 12.35-15.29 21.93-12.75 9.58 2.53 15.29 12.35 12.75 21.93Z"
                style={{
                    fill: "#b51a1a",
                    strokeWidth: 0,
                }}
            />
            <ellipse
                cx={293.33}
                cy={138.97}
                rx={53.42}
                ry={35.93}
                style={{
                    fill: "#35150b",
                    strokeWidth: 0,
                }}
            />
            <path
                d="M231.79 132.59s29.52 13.61 60.15 38.77c0 0 47.92-34.49 65.44-34.49l-65.83-30.31-59.75 26.03Z"
                style={{
                    fill: "#f6cb00",
                    strokeWidth: 0,
                }}
            />
            <path
                d="M245.62 138.68s-.76 11.3 6.29 12.65c7.04 1.35 10.25.08 17.29 6.37 7.04 6.29 11.95 4.59 16.65 3.09 4.7-1.49 9.82.02 14.73 1.4s9.82.74 13.02-2.25c3.2-2.99 7.04-5.76 11.74-5.76s16.35-8.71 16.9-16.96c.55-8.25-96.62 1.46-96.62 1.46Z"
                style={{
                    fill: "#00553c",
                    strokeWidth: 0,
                }}
            />
            <ellipse
                cx={293.33}
                cy={118.05}
                rx={55.86}
                ry={39.65}
                style={{
                    fill: "#d97533",
                    strokeWidth: 0,
                }}
            />
        </g>
        <path
            d="m328.65 289.1-5.27-80.57-5.35-5.79c-3.8-4.11-6.17-9.34-6.74-14.91l-1.83-17.82-8.39-19.21c-.91-2.08-.22-4.5 1.65-5.79l2.78-1.64-2.58-4.96a4.557 4.557 0 0 1 1.8-6.07l9.37-5.31 2.23-.81c3.08-1.11 6.5-.69 9.21 1.14l8.08 5.44c2.65 1.78 4.72 4.3 5.95 7.24l6.86 16.34c1.97 4.68 2.79 9.77 2.39 14.84l-1.92 24.3s27.53 58.91 42.62 93.59c15.08 34.68 12.57 78.25-27.23 89.14s-68.37-35.61-68.37-35.61V295.7l34.75-6.59Z"
            style={{
                fill: "#fdebd4",
                strokeWidth: 0,
            }}
        />
        <path
            d="m331.32 324.49-1.42-18.86M306.56 145.4l9.43 18.62M309.19 131.79s8.59 12.65 11.94 22.92M315.99 129.04s8.95 11.1 13.73 22.56M319.5 133.75l10.22 7.39"
            style={{
                fill: "none",
                stroke: "#35150b",
                strokeMiterlimit: 10,
            }}
        />
        <path
            d="m293.9 295.69 34.75-6.59.85 11.29s-34.06 27.83-35.6 43.09v-47.79Z"
            style={{
                fill: "#35150b",
                strokeWidth: 0,
            }}
        />
    </svg>
)
export default SvgComponent
